<template>
  <section class="case-creation__step case-creation__patient-information">
    <div class="case-creation__card">
      <div class="case-creation__heading">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-patient-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Create Accession</h3>
        </div>
      </div>
      <div class="case-creation__body">
        <div class="vue-form">
          <el-form :model="caseInformationFormData">
            <el-row :gutter="15">
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Laboratory
                      <span class="star">*</span>
                    </label>
                    <el-select
                      v-model="caseInformationFormData.lab"
                      placeholder="Please Select Lab"
                    >
                      <el-option
                        v-for="(lab, index) of getAllLabs"
                        :key="index"
                        :value="lab._id"
                        :label="lab.name"
                      ></el-option>
                    </el-select>
                    <p class="error" v-if="hasValidationError('lab')">
                      {{ getValidationError("lab") }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">Specimen Collector</label>
                    <el-input
                      v-model="caseInformationFormData.specimen_collector"
                    ></el-input>
                    <p
                      class="error"
                      v-if="hasValidationError('specimen_collector')"
                    >
                      {{ getValidationError("specimen_collector") }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Collection Date & Time
                      <span class="star">*</span>
                    </label>
                    <el-date-picker
                      type="datetime"
                      v-model="caseInformationFormData.collection_date"
                      placeholder="MM-DD-YYYY HH:MM AM"
                      format="MM-DD-YYYY hh:mm A"
                      @focus="checkDateValue"
                      @change="onDateFieldChange('collection_date')"
                      :disabled-date="disabledDate"
                      :default-time="defaultTime"
                    ></el-date-picker>

                    <p
                      class="error"
                      v-if="hasValidationError('collection_date')"
                    >
                      {{ getValidationError("collection_date") }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Received Date & Time
                      <span class="star">*</span>
                    </label>
                    <el-date-picker
                      type="datetime"
                      v-model="caseInformationFormData.received_date"
                      placeholder="MM-DD-YYYY HH:MM AM"
                      format="MM-DD-YYYY hh:mm A"
                      @focus="checkDateValue"
                      @change="onDateFieldChange('received_date')"
                      :disabled-date="disabledDate"
                      :default-time="defaultTime"
                    ></el-date-picker>

                    <p
                      class="err error-break"
                      v-if="hasValidationError('received_date')"
                    >
                      {{ getValidationError("received_date") }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">Marketer</label>
                    <el-input
                      type="text"
                      placeholder="Enter Marketer Details"
                      v-model="caseInformationFormData.marketer_details"
                      :rows="4"
                    ></el-input>
                    <p
                      class="err"
                      v-if="hasValidationError('marketer_details')"
                    >
                      {{ getValidationError("marketer_details") }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">Vendor</label>
                    <el-select
                      v-model="caseInformationFormData.vendor"
                      placeholder="Select Vendor"
                      clearable
                    >
                      <el-option
                        v-for="vendor in nonMlxVendors"
                        :key="vendor._id"
                        :value="vendor.code"
                        :label="vendor.name"
                      ></el-option>
                    </el-select>
                    <p
                      class="err"
                      v-if="hasValidationError('vendor')"
                    >
                      {{ getValidationError("vendor") }}
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="24" :lg="24" :md="8" :sm="12" :xs="12">
                <div
                  class="case-creation__actions"
                  v-if="hasPermission('orders', 'create_accession')"
                >
                  <ul class="list">
                    <li>
                      <el-button
                        class="btn cancel-button"
                        @click="cancelNewCase"
                        >Cancel</el-button
                      >
                    </li>
                    <li>
                      <el-tooltip
                        :content="
                          ackPendingConfirmation
                            ? 'Please confirm acknowledgment before creating accession'
                            : isSamplePending
                            ? 'Sample Approval Pending'
                            : ''
                        "
                        :disabled="!ackPendingConfirmation && !isSamplePending"
                        placement="top"
                      >
                        <span>
                          <el-button
                            class="btn save-button"
                            @click="showAccessionDialogPopUp"
                            :loading="loading"
                            :disabled="isSamplePending || ackPendingConfirmation"
                            >Create Accession</el-button
                          >
                        </span>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="hasCriticalError">
              <el-col :span="12">
                <p class="error">* {{ validationErrors.critical_error }}</p>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="default-modal">
      <el-dialog
        v-model="showAccessionPopup"
        width="1000px"
        :before-close="handlePopupClose"
        :close-on-click-modal="false"
        v-loading="loading"
        class="accession-dialog"
      >
        <div class="dialog-header">
          <span class="header-part"
            >Select Casetype for Accession Creation
          </span>
          <el-button @click="goBack" class="popup-back-button">
            <span class="plus-icon"
              ><img src="@/assets/images/icons/arrow-left.svg" alt="" /></span
            >Back
          </el-button>

          <el-button
            size="mini"
            class="el-white"
            type="info"
            plain
            @click="handlePopupClose"
          >
            <img
              src="@/assets/images/icons/cases/close-btn.svg"
              alt="close"
              style="width: 16px; height: 16px"
            />
          </el-button>
        </div>
        <div class="popup-date">
          <div
            class="listings listings__table listings__all-cases"
            id="all-cases-listings"
            v-loading="loading"
          >
            <el-table
              :data="filteredGroupedTubes"
              stripe
              border
              style="margin-top: 10px"
            >
              <el-table-column label="CASE TYPE" width="150">
                <template #default="{ row }">
                  <p class="case-type-text">{{ caseTypeMap[row.case_type] }}</p>
                  <el-tag size="mini" type="info" v-if="row.is_sendout"
                    >Sendout</el-tag
                  >
                  <el-tag size="mini" type="warning" v-if="row.is_allergy"
                    >Allergy</el-tag
                  ></template
                >
              </el-table-column>
              <el-table-column label="TEST DETAILS" width="350">
                <template #default="{ row }">
                  <el-select
                    multiple
                    collapse-tags
                    collapse-tags-tooltip
                    placeholder="Test Details"
                    class="disabled-dropdown"
                    :model-value="row.selected_tests"
                    readonly
                    style="pointer-events: none"
                  >
                    <el-option
                      v-for="(test, index) in row.selected_tests"
                      :key="`test-${test}-${index}`"
                      :label="test"
                      :value="test"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="ACTION">
                <template #default="{ row }">
                    <template v-if="row.status === 'REJECTED'">
                    <el-button
                      class="btn small-add-test-btn"
                      style="border: none"
                      type="danger"
                      disabled
                    >
                      Order Rejected
                    </el-button>
                  </template>
                  <template v-if="accessionCreatedMap[getRowKey(row)]">
                    <el-button
                      class="btn small-add-test-btn"
                      style="border: none"
                      type="success"
                      disabled
                    >
                      Accession Created
                    </el-button>
                  </template>
                  <template v-else>
                    <el-tooltip
                      :content="isSamplePending ? 'Sample Approval Pending' : ''"
                      :disabled="!isSamplePending"
                      placement="top"
                    >
                      <span>
                        <el-button
                          class="btn small-add-test-btn"
                          style="border: none"
                          :loading="
                            createAccessionLoadingMap[getRowKey(row)] || false
                          "
                          :disabled="isSamplePending"
                          @click="sumbitCaseInformation(row)"
                        >
                          Create Accession
                        </el-button>
                      </span>
                    </el-tooltip>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Barcodes">
                <template #default="{ row }">
                  <el-button
                    class="btn small-add-test-btn"
                    style="border: none"
                    :disabled="!accessionCreatedMap[getRowKey(row)] || createAccessionLoadingMap[getRowKey(row)] || (accessionCreatedMap[getRowKey(row)] && accessionCreatedMap[getRowKey(row)].sendoutCreated)"
                    @click="onPrintTestBarCodes(row)"
                    :title="(accessionCreatedMap[getRowKey(row)] && accessionCreatedMap[getRowKey(row)].sendoutCreated) ? 'Sendout case - printing disabled' : (!accessionCreatedMap[getRowKey(row)] ? 'Create accession first' : (row.case_type === 'CLINICAL_CHEMISTRY' ? (generatingBarcodesMap[getRowKey(row)] ? 'Generating barcodes...' : 'Print test barcodes') : 'Print barcode'))"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/test_barcode_white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/test_barcode.svg"
                        alt="icon"
                      />
                    </span>
                    <span v-if="row.case_type === 'CLINICAL_CHEMISTRY'">PRINT TESTBARCODES</span>
                    <span v-else>PRINT BARCODE</span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>
    </div>
    <ExistingCaseDetails
      v-if="errorDiloag"
      :convert="convertToCase"
      :existedCase="existedCaseDetails"
      :existedOrder="exisistingOrderData"
      v-on:closePopupDialog="handlePopUp"
      :caseType="caseInformationFormData.caseTypes"
      @approveCase="approveCase"
      :validationErrorMsg="validationError"
    >
    </ExistingCaseDetails>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import GlobalHelper from "@/mixins/GlobalHelper";
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);
import caseConstants from "@/config/constants/caseConstants";
import { successNotification } from "@/helpers/notifications";
export default {
  name: "CreateAccession",
  props: ["tubeInformationFromChild", "refetchTestInfo", "ackPendingConfirmation"],
  components: {
    ExistingCaseDetails,
  },
  mixins: [AppHelper, UserPermissionsHelper, GlobalHelper],
  async mounted() {
    // multi accession moved to live for DLW
    await this.$store.commit(
      "orders/setAccessionCreationValidationErrors",
      {},
      {
        root: true,
      }
    );
    await this.getCaseData();
    await this.$store.dispatch("labs/fetchAllLabs", { get_all: true });
    await this.$store.dispatch("vendors/fetchVendors", { skip: 0, limit: 100 });
    await this.$store.commit("errors/clear", null, { root: true });

    if (this.getUserPrimaryLabId) {
      this.caseInformationFormData.lab = this.getUserPrimaryLabId;
    }
  },
  computed: {
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("auth", ["getUserPrimaryLabId"]),
    ...mapGetters("vendors", ["getAllVendors"]),
    nonMlxVendors() {
      return (this.getAllVendors || []).filter((v) => !v.is_mlx);
    },
    ...mapGetters("orders", [
      "getCaseInformation",
      "getAccessionCreationValidationErrors",
      "getAccessionCreateStatus",
      "getAccessionCreationValidationErrorCode",
      "getCreateAccessionDetails",
      "getSingleOrderTestsInfo",
      "getCaseConversionErrorsStatus",
      "getTestTubeInfoById",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    // Computed property for validation errors to avoid repeated access
    validationErrors() {
      return this.getAccessionCreationValidationErrors || {};
    },
    hasCriticalError() {
      return !!this.validationErrors.critical_error;
    },
    isSamplePending() {
      return !!this.getCaseInformation?.sample_pending;
    },
    isVendorFrozen() {
      return !!this.initialVendorFromOrder;
    },
    groupedTubes() {
      return (
        this.tubeInformationFromChild || {
          sendout: [],
          nonsendout: [],
          allergy: [],
        }
      );
    },
    filteredGroupedTubes() {
      const grouped = this.groupedTubes || {};
      const merged = {};

      const restrictedOrderCodes = this.getCaseInformation?.restricted_order_codes;
      const isPendingRestricted =
        restrictedOrderCodes &&
        Array.isArray(restrictedOrderCodes.order_codes) &&
        restrictedOrderCodes.order_codes.length > 0 &&
        String(restrictedOrderCodes.status || "").toUpperCase() === "PENDING";
      const restrictedSet = isPendingRestricted
        ? new Set(restrictedOrderCodes.order_codes)
        : new Set();

      const processGroup = (groupList, is_sendout, is_allergy = false) => {
        if (!Array.isArray(groupList)) return;

        groupList.forEach((group) => {
          const { case_type, tubes } = group;

          // Skip groups where all tubes are "Not Collected" or "Hemolyzed"
          const hasCollectedTube =
            Array.isArray(tubes) &&
            tubes.some(
              (tube) =>
                tube.status !== "Not Collected" &&
                tube.status !== "Hemolyzed"
            );
          if (!hasCollectedTube) return;

          const selected_tests = (group.selected_tests || []).filter(
            (test) => !restrictedSet.has(test)
          );

          if (!Array.isArray(selected_tests) || selected_tests.length === 0)
            return;

          const key = `${case_type}_${
            is_allergy ? "allergy" : is_sendout ? "sendout" : "nonsendout"
          }`;
          if (!merged[key]) {
            merged[key] = {
              case_type,
              is_sendout,
              is_allergy,
              selected_tests: [],
              tubes: [],
            };
          }
          // Merge tests
          merged[key].selected_tests.push(...selected_tests);

          // Merge tubes
          if (Array.isArray(tubes)) {
            tubes.forEach((tube) => {
              merged[key].tubes.push({
                tube_id: tube.tube_id,
                tube_name: tube.tube_name,
                image_url: tube.image_url,
                status: tube.status === "Collected",
              });
            });
          }
        });
      };

      processGroup(grouped.sendout, true);
      processGroup(grouped.nonsendout, false);
      processGroup(grouped.allergy, false, true);

      // Remove duplicate test names
      Object.values(merged).forEach((group) => {
        group.selected_tests = [...new Set(group.selected_tests)];
      });

      return Object.values(merged);
    },
    tubeInfo() {
      return this.getCaseInformation?.test_tube_information || [];
    },
    CaseTypeDisable() {
      return (
        this.getCaseInformation?.accession_data?.map((obj) => obj.case_type) ||
        []
      );
    },
  },
  watch: {
    getUserPrimaryLabId(val) {
      if (val && !this.caseInformationFormData.lab) {
        this.caseInformationFormData.lab = val;
      }
    },
  },
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      defaultTime: [new Date()],
      errorDiloag: false,
      convertToCase: true,
      existedCaseDetails: {},
      exisistingOrderData: {},
      caseInformationFormData: {
        lab: "",
        collection_date: "",
        received_date: new Date(),
        caseTypes: [],
        vendor: "",
      },
      // Value each date picker started from, used as previous_value when audit logging
      dateAuditBaseline: {
        collection_date: null,
        received_date: null,
      },
      initialVendorFromOrder: "",
      loading: false,
      accessionCreatedMap: {},
      createAccessionLoadingMap: {},
      generatingBarcodesMap: {},
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      validationError: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      specimenTypes: [],
      coriell_test_panels: [],
      medicalNecessities: [],
      icdErrorDialog: false,
      billingErrors: [],
      insurancePopup: false,
      insuranceEligibilityDetails: {},
      foundCoverages: [],
      errorMessage: "",
      caseIdToInsurance: "",
      showAccessionPopup: false,
      selectedRow: null,
    };
  },
  methods: {
    trimObjectStrings(obj) {
      if (Array.isArray(obj)) {
        return obj.map(item => this.trimObjectStrings(item));
      } else if (obj !== null && typeof obj === "object") {
        const newObj = {};
        Object.keys(obj).forEach(key => {
          newObj[key] = this.trimObjectStrings(obj[key]);
        });
        return newObj;
      } else if (typeof obj === "string") {
        return obj.trim();
      }
      return obj;
    },
    // Helper to get validation error for a field
    getValidationError(field) {
      if (!field || typeof field !== "string") return "";
      return this.validationErrors[field] || "";
    },
    // Check if field has validation error
    hasValidationError(field) {
      if (!field || typeof field !== "string") return false;
      return !!this.validationErrors[field];
    },
    goBack() {
      this.showAccessionPopup = false;
      // If any accession was created while the popup was open, the order state
      // has changed (tests converted, status updated). Ask the parent to refresh
      // so returning to the order doesn't show stale data.
      if (Object.keys(this.accessionCreatedMap).length > 0) {
        this.$emit("update-refetch-test-info", true);
      }
    },
    getRowKey(row) {
      return `${row.case_type}_${
        row.is_allergy ? "allergy" : row.is_sendout ? "sendout" : "normal"
      }`;
    },
    async handlePopupClose() {
      if (this.getCaseConversionErrorsStatus) {
        this.showAccessionPopup = false;
        this.$store.commit("orders/setCaseConversionErrorsStatus", false);
        this.$notify?.error?.({
          title: "Error",
          message: "Error while creating accession ID.",
        });
      } else {
        this.showAccessionPopup = false;
        this.cancelNewCase();
      }
    },
    filteredPatient(patient) {
      const filtered = {};
      for (const key in patient) {
        if (key !== "addresses") {
          filtered[key] = patient[key];
        }
      }
      return filtered;
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },
    async getCaseData() {
      const orderId = this.$route.params.order_id;
      if (!orderId) {
        this.loading = false;
        return;
      }
      try {
        await this.$store.dispatch("orders/fetchCaseInformation", {
          order_id: orderId,
        });
        if (this.getCaseInformation?.collection_date) {
          this.caseInformationFormData.collection_date =
            this.convertLabUTCToClient(this.getCaseInformation.collection_date);
        }
        this.dateAuditBaseline = {
          collection_date: this.caseInformationFormData.collection_date || null,
          received_date: this.caseInformationFormData.received_date || null,
        };
        // Set vendor from order and freeze if exists
        if (this.getCaseInformation?.vendor) {
          this.caseInformationFormData.vendor = this.getCaseInformation.vendor;
          this.initialVendorFromOrder = this.getCaseInformation.vendor;
        }
        await this.prepreCaseDataFromFormData();
        if (this.getCaseInformation?.case_types?.length === 1) {
          this.caseInformationFormData.caseTypes =
            this.getCaseInformation.case_types;
        }
      } catch (error) {
        console.error("Error fetching case data:", error);
      } finally {
        this.loading = false;
      }
    },
    // Collection / received date edits are audited server side, so report the
    // before and after values whenever either picker changes
    async onDateFieldChange(field) {
      const orderId = this.$route.params.order_id;
      if (!orderId) return;

      const toTime = (value) => (value ? new Date(value).getTime() : null);
      const previous = this.dateAuditBaseline[field] || null;
      const present = this.caseInformationFormData[field] || null;
      if (toTime(previous) === toTime(present)) return;

      this.dateAuditBaseline[field] = present;

      await this.$store.dispatch("orders/logOrderDateChange", {
        order_id: orderId,
        changes: [
          {
            field,
            previous_value: previous ? this.convertToLabUTC(previous) : null,
            present_value: present ? this.convertToLabUTC(present) : null,
          },
        ],
      });
    },
    async prepreCaseDataFromFormData() {
      const tubes = this.transformSelectedRow(
        this.selectedRow,
        this.getTestTubeInfoById
      );
      const filteredTestsBySelectedCaseType = tubes;

      // Cache getCaseInformation to avoid repeated property access
      const caseInfo = this.getCaseInformation;
      if (!caseInfo) return {};

      const params = {
        case_types: this.caseInformationFormData.caseTypes,
        icd_10_codes: caseInfo.icd_10_codes,
        is_insurance_uploaded: caseInfo.is_insurance_uploaded,
        status: caseInfo.status,
        billing_status: caseInfo.billing_status,
        patient_order: caseInfo.patient_order,
        lab: this.getUserPrimaryLabId,
        collection_date: this.convertToLabUTC(
          this.caseInformationFormData.collection_date
        ),
        test_tube_information: filteredTestsBySelectedCaseType,
        received_date: this.convertToLabUTC(
          this.caseInformationFormData.received_date
        ),
        hospital: caseInfo.hospital?._id || null,
        ordering_physician: caseInfo.ordering_physician?._id || null,
        referring_physician: caseInfo.referring_physician?._id || null,
        hospital_branch: caseInfo.hospital_branch?._id || null,
        billing_type: caseInfo.billing_type,
        specimen_collector: caseInfo.specimen_collector,
        requisition_order_id: caseInfo.requisition_order_id,
        patient_info: { ...caseInfo.patient_info },
        covid_status: caseInfo.covid_status,
        test_results: caseInfo.test_results,
        test_reports: caseInfo.test_reports,
        attachments: caseInfo.attachments,
        internal_documents: caseInfo.internal_documents,
        internal_notes: caseInfo.internal_notes,
        signature_settings: caseInfo.signature_settings,
        order: this.$route.params.order_id,
        order_id: caseInfo.order_id,
        // Conditionally add phlebio_order_id only if it exists
        ...(caseInfo.phlebio_order_id
          ? { phlebio_order_id: caseInfo.phlebio_order_id }
          : {}),
        billing_info:this.trimObjectStrings(caseInfo?.billing_info || {})  
      };
      params.medication = caseInfo.medication?.length
        ? caseInfo.medication
        : ["NOT AVAILABLE"];

      params.issues = [];
      params.send_to_phlebio = true;
      return params;
    },
    async approveCase(response) {
      const rowKey = this.getRowKey(this.selectedRow);
      this.createAccessionLoadingMap = {
        ...this.createAccessionLoadingMap,
        [rowKey]: true,
      };

      try {
        const tubes = this.transformSelectedRow(
          this.selectedRow,
          this.getTestTubeInfoById
        );
        this.errorDiloag = response;
        await this.$store.commit("errors/clear");
        this.loading = true;

        const orderId = this.$route.params.order_id;
        const params = {
          ...this.prepreDataFromFormData(),
          order: orderId,
          auto_approved: true,
          billing_acknowledged: true,
          test_tube_information: tubes,
          is_insurance_uploaded: this.getCaseInformation?.is_insurance_uploaded,
          send_to_phlebio: true,
        };

        await this.$store.dispatch("orders/createAccessionForOrder", params);
        this.handleResponse(params);

        if (this.getAccessionCreateStatus) {
          const accessionId =
            this.getCreateAccessionDetails?._id ||
            this.getCreateAccessionDetails?.accession_id ||
            true;
          const sendoutCreatedFlag =
            !!this.getCreateAccessionDetails?.sendoutCreated;
          this.accessionCreatedMap = {
            ...this.accessionCreatedMap,
            [rowKey]: { id: accessionId, sendoutCreated: sendoutCreatedFlag },
          };
        }
      } catch (error) {
        console.error("Error approving case:", error);
      } finally {
        this.loading = false;
        this.createAccessionLoadingMap = {
          ...this.createAccessionLoadingMap,
          [rowKey]: false,
        };
      }
    },
    async showAccessionDialogPopUp() {
      this.showAccessionPopup = true;
    },
     onPrintTestBarCodes(row) {
      // Determine accession id from map; support both object and primitive legacy values
      const rowKey = this.getRowKey(row);
      if (row.case_type === 'CLINICAL_CHEMISTRY') {
        this.generatingBarcodesMap = { ...this.generatingBarcodesMap, [rowKey]: true };
        setTimeout(() => {
          this.generatingBarcodesMap = { ...this.generatingBarcodesMap, [rowKey]: false };
        }, 1500);
      }
      const stored = this.accessionCreatedMap[rowKey];
      const accessionId = stored ? (typeof stored === 'object' ? stored.id : stored) : (this.getCreateAccessionDetails?._id || this.getCreateAccessionDetails?.accession_id);
      if (!accessionId || accessionId === true) {
        this.$notify?.error?.({ title: 'Error', message: 'Accession ID unavailable for printing.' });
        return;
      }
      if (row.case_type === 'CLINICAL_CHEMISTRY') {
        const urlData = this.$router.resolve({
          name: 'MultipleTestBarcodes',
          path: 'multiple-test-barcodes',
          query: {
            case_ids: accessionId,
            case_type: row.case_type,
            sendout: row.is_sendout || false,
            allergy: row.is_allergy || false,
          },
        });
        window.open(urlData.href, '_blank');
      } else {
        const urlData = this.$router.resolve({
          name: 'MultipleBarcodes',
          path: 'multiple-barcodes',
          query: {
            case_ids: accessionId,
            case_type: row.case_type,
            sendout: row.is_sendout || false,
            allergy: row.is_allergy || false,
          },
        });
        window.open(urlData.href, '_blank');
      }
      // Keep popup and current page open after printing per new requirement.
      // Optionally could refresh data if needed, but leaving state untouched.
    },
    transformSelectedRow(row, testTubeInfoList) {
      if (!row?.selected_tests?.length || !Array.isArray(testTubeInfoList)) {
        return [];
      }

      const transformed = [];
      const tubeMap = new Map(); // Use Map for O(1) lookups

      row.selected_tests.forEach((test) => {
        // Find matching test in tube info
        for (const tubeInfo of testTubeInfoList) {
          const testMatch = tubeInfo.tests?.find(
            (t) =>
              t.title === test &&
              t.case_type?.includes(row.case_type) &&
              (t.is_sendout ?? false) === row.is_sendout &&
              (t.is_allergy ?? false) === (row.is_allergy ?? false)
          );

          if (testMatch) {
            const matchedTube = row.tubes?.find(
              (t) => t.tube_name === tubeInfo.tube_name
            );

            if (matchedTube) {
              const existingTube = tubeMap.get(matchedTube.tube_id);

              if (existingTube) {
                existingTube.collected_tests.push(test);
              } else {
                const newTube = {
                  tube_id: matchedTube.tube_id,
                  tube_name: matchedTube.tube_name,
                  image_url: matchedTube.image_url || "",
                  status: "Collected",
                  collected_tests: [test],
                };
                tubeMap.set(matchedTube.tube_id, newTube);
                transformed.push(newTube);
              }
            }

            break; // No need to search further
          }
        }
      });

      return transformed;
    },
    async sumbitCaseInformation(row) {
      this.caseInformationFormData.caseTypes = [row.case_type];
      const rowKey = this.getRowKey(row);
      const tubes = this.transformSelectedRow(row, this.getTestTubeInfoById);
      const filteredTestsBySelectedCaseType = tubes;
      this.selectedRow = row;
      this.createAccessionLoadingMap = {
        ...this.createAccessionLoadingMap,
        [rowKey]: true,
      };

      try {
        this.loading = true;
        const orderId = this.$route.params.order_id;
        let params = this.prepreDataFromFormData();
        params.order = orderId;
        params.billing_acknowledged = true;
        params.sendout_required = row.is_sendout;
        params.is_allergy = row.is_allergy || false;
        params.is_insurance_uploaded =
          this.getCaseInformation.is_insurance_uploaded;
        params.test_tube_information = filteredTestsBySelectedCaseType;
        params.send_to_phlebio = true;
        params.patient_info = this.filteredPatient(
          this.getCaseInformation.patient_info
        );
        params.billing_info = this.trimObjectStrings(
          this.getCaseInformation?.billing_info || {}
        );
        params.approval_pending = this.getCaseInformation?.approval_pending;
        params.is_approval_required = this.getCaseInformation?.is_approval_required;
        await this.$store.dispatch("orders/createAccessionForOrder", params);
        if (this.getAccessionCreateStatus) {
          const accessionId =
            this.getCreateAccessionDetails?._id ||
            this.getCreateAccessionDetails?.accession_id ||
            true;
          const sendoutCreatedFlag =
            !!this.getCreateAccessionDetails?.sendoutCreated;
          this.accessionCreatedMap = {
            ...this.accessionCreatedMap,
            [rowKey]: { id: accessionId, sendoutCreated: sendoutCreatedFlag },
          };
        }
        this.loading = false;
        await this.handleResponse(params);
      } catch (err) {
        console.error("Error creating accession:", err);
        this.$notify.error({
          title: "Error",
          message: "Error while creating accession",
        });
      } finally {
        this.loading = false;
        //  Clone again and update
        this.createAccessionLoadingMap = {
          ...this.createAccessionLoadingMap,
          [rowKey]: false,
        };
      }
    },
    async handleResponse(params) {
      if (this.getAccessionCreateStatus) {
        successNotification("Accession id created successfully");
        this.loading = false;
        // Do not auto navigate; wait for print button.
      } else {
        const errorCode =
          this.getAccessionCreationValidationErrorCode?.error_code;
        const errorCodes = [
          "GENETIC_TEST_EXISTED",
          "TEST_ALREADY_EXISTED",
          "NON_GENTIC_TEST_VALIDATE",
          "DUPLICATE_EXISTED",
        ];
        if (errorCodes.includes(errorCode)) {
          this.errorDiloag = true;
          this.validationError = errorCode;
          if (
            this.getAccessionCreationValidationErrorCode?.errors
              ?.existed_details
          ) {
            this.existedCaseDetails =
              this.getAccessionCreationValidationErrorCode.errors.existed_details;
          }
          this.exisistingOrderData = await this.prepreCaseDataFromFormData();
          if (this.getCaseInformation?.physician_notes) {
            this.exisistingOrderData.physician_notes =
              this.getCaseInformation.physician_notes;
          }
        } else if (errorCode === "BILLING_VALIDATION_ERRORS") {
          this.icdErrorDialog = true;
          this.billingErrors =
            this.getAccessionCreationValidationErrorCode?.errors || [];
        } else if(this.getAccessionCreationValidationErrors){
          this.handlePopupClose()
        } else if (!this.getAccessionCreationValidationErrors) {
          this.$notify.error({
            title: "Error",
            message: "Error while creating accession",
          });
        }
      }
    },
    async cancelNewCase() {
      // User explicitly clicked Cancel; keep previous auto-navigation removed.
      this.$router.push({
        path: "all-orders/active",
        name: "ActiveOrders",
        query: this.$route.query,
      });
    },
    prepreDataFromFormData() {
      const formData = this.caseInformationFormData;
      return {
        lab: formData.lab || this.getUserPrimaryLabId || undefined,
        collection_date: this.convertToLabUTC(formData.collection_date),
        received_date: this.convertToLabUTC(formData.received_date),
        marketer_details: formData.marketer_details || undefined,
        specimen_collector: formData.specimen_collector || undefined,
        case_types: formData.caseTypes || undefined,
        vendor: formData.vendor || undefined,
      };
    },

  },
}
</script>
<style lang="scss" scoped>
.error {
  margin-top: 2px !important;
  color: #eb5757;
  font-size: 12px;
  min-height: 20px;
  white-space: nowrap;
  margin-bottom: -30px;
  line-height: 20px;
  font-weight: 500;
  padding-left: 2px;
}
#insurance-details {
  border: 1.5px solid #e7e7f7;
  border-radius: 10px;
  margin: 15px;
  padding: 5px;
  .insurance-details-block {
    height: 500px;
    overflow: auto;
    padding: 5px 15px;
    ul {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;
      .insurance-details-list {
        border: 1.5px solid #e7e7f7;
        margin: 5px 0;
        overflow: hidden;
        border-radius: 10px;

        .insurance-block {
          display: grid;
          // grid-template-columns: 1.5fr 3fr;
          align-items: baseline;
          column-gap: 20px;
          font-weight: 500;
          color: #000000;
          span:nth-child(2) {
            padding: 5px 15px;
          }
        }
        .insurance-label {
          color: #005475;
          font-weight: 600;
          font-size: 15px;
          text-transform: capitalize;
          background: #f3f3f3;
          padding: 5px 15px;
        }
        .insurance-sub-order {
          .insurance-sub-list {
            .insurance-sub-block {
              display: grid;
              grid-template-columns: 1.5fr 3fr;
            }
          }
        }

        .main-sub-block {
          .insurance-sub-block {
            border: 1.5px solid #e7e7f7;
            margin: 5px 0;
            overflow: hidden;
            border-radius: 10px;
            &.m-10 {
              margin: 10px;
            }
          }
          &:nth-child(8),
          &:nth-child(9),
          &:nth-child(10),
          &:nth-child(12),
          &:nth-child(13) {
            .Patient-details {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              column-gap: 20px;
              row-gap: 5px;
              color: #000000;
              margin: 0 10px;
              li {
                border: 1.5px solid #e7e7f7;
                margin: 5px 0;
                overflow: hidden;
                border-radius: 10px;
                span:nth-child(2) {
                  padding: 5px 15px;
                  display: inline-flex;
                }
              }
              .insurance-label {
                color: #273480;
                font-weight: 500;
              }
            }
            .insurance-sub-block {
              display: block;
            }
          }
          &:nth-child(16) {
            .insurance-sub-block {
              display: block;
            }
            .Patient-details {
              margin: 0 10px;
              grid-template-columns: 1fr;
              li {
                border: 1.5px solid #e7e7f7;
                margin: 5px 0;
                overflow: hidden;
                border-radius: 10px;
                span:nth-child(2) {
                  padding: 5px 15px;
                  display: inline-flex;
                }
              }
            }
          }
        }
        &:nth-child(7) {
          grid-column: 1 / span 3;
          .insurance-block {
            display: block;
            .insurance-sub-order {
              grid-template-columns: 1fr;
            }
            .insurance-sub-list {
              display: grid;
              grid-template-columns: 1fr;
              column-gap: 20px;
              margin: 10px;
            }
          }
        }
      }
    }
  }
  .sub-details-block {
    .Patient-details {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;
      row-gap: 5px;
      color: #000000;
      margin: 10px;
      li {
        border: 1.5px solid #e7e7f7;
        margin: 5px 0;
        overflow: hidden;
        border-radius: 10px;
        span:nth-child(2) {
          padding: 5px 15px;
          display: inline-flex;
        }
      }
      .insurance-label {
        color: #273480;
        font-weight: 500;
      }
    }
  }
}
.popup-back-button {
  border: 1px solid #d9d9d9 !important;
  position: absolute;
  width: 75px !important;
  display: flex;
  border-radius: 16px !important;
  right: 40px !important;
  :deep(span) {
    min-height: auto;
    color: #333;
    font-weight: 500;
    border-radius: 30px;
    transition: all 0.2s ease-in-out;
    font-size: 0.9em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 10px;
    .plus-icon {
      margin-right: 0px;
      width: 16px;
      top: 0 !important;
      left: 0;
      img {
        top: 0 !important;
      }
    }
  }
}
</style>
